import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { getPharmacyDisplayName } from '../../handle/get-pharmacy-display-name.handle';

export const platformNames = {
	mkt: 'Marketplace',
	ecc: 'Ecommerce',
	tirxs: 'Tirxs',
	benestarx: 'Benestarx',
	pharol: 'pharol',
};

export const nameAdapter = (pharmacy) => {
	if (!pharmacy) return platformNames.ecc;

	if (pharmacy === platformNames.pharol) {
		if (Enviroment.COUNTRY === 'MX') {
			return `${platformNames.mkt} ${platformNames.benestarx}`;
		}
		return `${platformNames.mkt} ${platformNames.tirxs}`;
	}

	return `${platformNames.ecc} ${getPharmacyDisplayName(pharmacy)}`;
};
